module.exports = __webpack_public_path__ + "static/vision-and_strategy_development-294ffa62b6aaee4067e7029ef0d9b9a0.jpg";